/**
 * Coleção: theme.collectionPage, theme.filter (activeFilters, priceRange),
 * Ordenação: só dentro da gaveta de filtros (#FilterForm, acordeão com radios sort_by).
 * Depende de global.js (theme, utilities, component, storageKeys), base.js,
 * product.js em runtime (customSwatchColors no render da coleção).
 *
 * Ordem no layout: após global.js; antes de shipping-rates.js ou cart.js.
 */

theme.collectionPage = {
    container: document.querySelector(".collection"),
    productList: document.querySelector(".collection__product-list"),
    productGrid: document.getElementById("product-grid"),
    render: function () {
      if (this.productList) {
        theme.filter.render();
        window.addEventListener(
            "popstate",
            this.handlePopstateEvent.bind(this)
          );
      }
    },
    handlePopstateEvent: function (e) {
      var t = document.getElementById("product-grid").dataset.id;
      (e = e.state ? e.state.params : ""),
        (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  };

  theme.filter = {
    filterForm: document.getElementById("FilterForm"),
    productGrid: document.getElementById("product-grid"),
    selectors: {
      productContainer: "ProductGridContainer",
      productGrid: "product-grid",
      filters: "ProductFilters",
      filtersMobile: "ProductFiltersMobile",
      filterTags: "filterByTag",
      activeTags: "CollectionActiveTags",
      resultsLabel: "FilterResultsLabel",
      activeCount: "FilterActiveCount",
    },
    productGridContainer: document.getElementById("ProductGridContainer"),
    render: function () {
      this.filterForm &&
        (this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
          this.priceRange.init(),
          this.renderActiveFilters());
      // As cores das amostras vêm de theme.product (product.js, carregado depois deste arquivo)
      if (document.readyState === "complete") this.renderSwatchFilter();
      else document.addEventListener("DOMContentLoaded", () => this.renderSwatchFilter(), { once: true });
    },
    // Várias mudanças no mesmo instante (as duas alças do preço disparam "change" juntas) = uma busca só.
    handleFormChange: function (e) {
      e.preventDefault();
      clearTimeout(this.changeTimer);
      this.changeTimer = setTimeout(() => {
        var params = this.getSearchParams();
        this.updateURL(params);
        this.getProductList(theme.utilities.getSectionUrl(params));
      }, 0);
    },
    // Filtros + ordenação da gaveta (#FilterForm)
    getSearchParams: function () {
      var filterForm = document.getElementById("FilterForm");
      return new URLSearchParams(filterForm ? new FormData(filterForm) : undefined).toString();
    },
    getProductList: function (e) {
      let t = this;
      let drawer = document.getElementById("FilterDrawer");
      drawer && drawer.classList.add("is-loading");
      this.productGrid.classList.remove("finished"),
        this.productGrid.classList.add("loading"),
        fetch(e)
          .then((e) => e.text())
          .then((e) => {
            this.productGrid.classList.add("loaded"),
              this.productGrid.classList.remove("loading"),
              this.renderProductGrid(e),
              this.renderProductFilters(e),
              setTimeout(function () {
                t.productGrid.classList.add("finished"),
                  t.productGrid.classList.remove("loaded");
              }, 300);
          })
          .finally(() => {
            drawer && drawer.classList.remove("is-loading");
          });
    },
    renderProductGrid: function (e) {
      let t = new DOMParser().parseFromString(e, "text/html"),
        i = this.productGrid.className;
      let n = t.querySelector(".collection__product-list");
      n &&
        ((this.productGridContainer.innerHTML = t.getElementById(
            this.selectors.productContainer
          ).innerHTML),
          window.scrollTo({
            top: this.productGridContainer.offsetTop - 100,
            behavior: "smooth",
          }),
          (this.productGrid = document.getElementById(
            this.selectors.productGrid
          )),
          (this.productGrid.className = i),
          theme.utilities.applyAnimation());
    },
    renderProductFilters: function (e) {
      (e = new DOMParser().parseFromString(e, "text/html")),
        (document.getElementById(this.selectors.filters).innerHTML =
          e.getElementById(this.selectors.filters).innerHTML),
        (document.getElementById(this.selectors.activeTags).innerHTML =
          e.getElementById(this.selectors.activeTags).innerHTML),
        this.renderCounters(e),
        this.renderPriceRange(),
        (this.filterForm = document.getElementById("FilterForm")),
        this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
        this.renderActiveFilters(),
        this.renderSwatchFilter(),
        teamdropInitTooltips(document);
    },
    // "Ver resultados (N)" no rodapé da gaveta e contador de filtros ativos do botão flutuante
    renderCounters: function (doc) {
      [this.selectors.resultsLabel, this.selectors.activeCount].forEach(function (id) {
        var current = document.getElementById(id);
        var next = doc.getElementById(id);
        if (!current || !next) return;
        current.textContent = next.textContent;
        current.hidden = next.hidden;
      });
    },
    renderPriceRange: function () {
      this.priceRange.init();
    },
    updateURL: function (e) {
      history.pushState({ params: e }, "", window.location.pathname + "?" + e);
    },
    renderActiveFilters: function () {
      let e = Object.create(this.activeFilters);
      (e.appliedFilters = document.querySelectorAll("#CollectionActiveTags a")),
        e.render();
    },
    // Cor das bolinhas (filtro e chips) pela lista "Cores das amostras" do tema, quando a Shopify não mandou cor
    renderSwatchFilter: function () {
      let els = document.querySelectorAll(".collection-filters__swatch[data-swatch], .filter-chips__swatch[data-swatch]");
      if (!els.length || !theme.product || !theme.product.customSwatchColors) return;
      let colors = theme.product.customSwatchColors();
      els.forEach((el) => {
        if (el.style.getPropertyValue("--swatch-background-color")) return;
        let color = colors[el.dataset.swatch.toLowerCase()];
        color && el.style.setProperty("--swatch-background-color", color);
      });
    },
  };

  theme.filter.activeFilters = {
    appliedFilters: document.querySelectorAll("#CollectionActiveTags a"),
    render: function () {
      0 !== this.appliedFilters.length &&
        this.appliedFilters.forEach((e) => {
          e.addEventListener(
            "click",
            this.handleActiveFilterOnClick.bind(this)
          );
        });
    },
    handleActiveFilterOnClick: function (e) {
      e.preventDefault(),
        (e =
          -1 == e.currentTarget.href.indexOf("?")
            ? ""
            : e.currentTarget.href.slice(
              e.currentTarget.href.indexOf("?") + 1
            ));
      var t =
        (theme.filter.updateURL(e),
          document.getElementById("product-grid").dataset.id);
      (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  };

  // Filtro de preço: duas barras nativas sobrepostas (.price-bar__range) + dois campos com o nome do filtro.
  // Só os campos vão para a busca; a barra copia o valor para o campo e o "change" sobe até o #FilterForm.
  theme.filter.priceRange = {
    init: function () {
      var root = document.querySelector(".filter-price");
      if (!root) return;
      var bar = root.querySelector(".price-bar");
      var ranges = root.querySelectorAll(".price-bar__range");
      var inputs = [root.querySelector(".filter-price__input--min"), root.querySelector(".filter-price__input--max")];
      if (!bar || ranges.length !== 2 || !inputs[0] || !inputs[1]) return;
      var max = parseInt(ranges[1].max, 10);

      // As alças nunca se cruzam: a de baixo fica pelo menos 1 abaixo da de cima.
      var clamp = function (index, value) {
        var other = parseInt(ranges[1 - index].value, 10);
        if (isNaN(value)) value = index === 0 ? 0 : max;
        return index === 0 ? Math.max(0, Math.min(value, other - 1)) : Math.min(max, Math.max(value, other + 1));
      };
      var paint = function () {
        bar.style.setProperty("--price-min", ranges[0].value / max);
        bar.style.setProperty("--price-max", ranges[1].value / max);
      };

      ranges.forEach(function (range, index) {
        range.addEventListener("input", function () {
          range.value = clamp(index, parseInt(range.value, 10));
          inputs[index].value = range.value;
          paint();
        });
      });
      inputs.forEach(function (input, index) {
        input.addEventListener("change", function () {
          if (input.value === "") {
            ranges[index].value = index === 0 ? 0 : max;
          } else {
            input.value = clamp(index, parseInt(input.value, 10));
            ranges[index].value = input.value;
          }
          paint();
        });
      });
    },
  };


document.addEventListener("shopify:section:load", function (event) {
  if (!event.target || !event.target.querySelector(".collection")) return;
  theme.collectionPage.container = document.querySelector(".collection");
  theme.collectionPage.productList = document.querySelector(".collection__product-list");
  theme.collectionPage.productGrid = document.getElementById("product-grid");
  theme.collectionPage.render();
});

// Auto-init: script defer roda após DOM parseado.
theme.collectionPage.render();
